import React from 'react'
import MarkerWithLabel from './MarkerWithLabel'
import helpers from '../helpers'

const OrderMap = ({ data }) => (
  <React.Fragment>
    <MarkerWithLabel
      location={data.deliveryLocation}
      icon={helpers.icons.deliveryLocation}
      label='Delivery Location'
      labelColor={helpers.getLabelColor('available')}
    />

    <MarkerWithLabel
      location={data.requestCoords}
      icon={helpers.icons.requestLocation}
      label='Request Coords'
      labelColor={helpers.getLabelColor()}
    />
  </React.Fragment>
)

export default OrderMap



// WEBPACK FOOTER //
// ./src/containers/mapView/components/OrderMap.js